import type { SearchBusinessTrustPilotResultType } from "@/api/reviewTrustPilotApi";

const getHostnameFromWebsite = (website?: string) => {
  const value = website?.trim();

  if (!value) {
    return "";
  }

  const valueWithProtocol = /^[a-z][a-z\d+\-.]*:\/\//i.test(value)
    ? value
    : `https://${value}`;

  try {
    return new URL(valueWithProtocol).hostname.replace(/^www\./i, "");
  } catch {
    return value
      .replace(/^https?:\/\//i, "")
      .replace(/^www\./i, "")
      .split(/[/?#]/)[0];
  }
};

export const getTrustPilotBusinessDomain = (
  business: SearchBusinessTrustPilotResultType,
) => {
  const identifyingName = business.identifyingName?.trim();

  if (identifyingName && !/\s/.test(identifyingName)) {
    return identifyingName;
  }

  return (
    getHostnameFromWebsite(business.contact?.website) ||
    identifyingName ||
    business.businessUnitId
  );
};
